module.exports = __webpack_public_path__ + "media/src/StayPackage/images/checkPoint-5e92dc56a03d757dd174b305d69d8cc5.svg";